import React from 'react';
import useFormFieldProps, {
    FormFieldProps,
    useFormInputProps,
    useFormInputValidationProps
} from './useFormFieldProps';
import HBRadioButtonGroup, {
    HBRadioButtonGroupProps
} from '../HBRadioButtonGroup/HBRadioButtonGroup';
import HBRadioButtonGroupField, {
    HBRadioButtonGroupFieldProps
} from '../HBRadioButtonGroupField/HBRadioButtonGroupField';

const HBFormRadioButtonGroupField = <Value extends string | number>(
    props: FormFieldProps<HBRadioButtonGroupFieldProps<Value>>
) => {
    const fieldProps = useFormFieldProps(props);
    const validationProps = useFormInputValidationProps(props.id);

    return <HBRadioButtonGroupField {...fieldProps} {...validationProps} />;
};

export const HBFormRadioButtonGroup = <Value extends string | number>(
    props: FormFieldProps<HBRadioButtonGroupProps<Value>>
) => {
    const { testIdName, ...inputProps } = useFormInputProps(props);
    const validationProps = useFormInputValidationProps(props.id);

    return (
        <HBRadioButtonGroup
            {...inputProps}
            {...validationProps}
            testIdName={testIdName}
        />
    );
};

export default HBFormRadioButtonGroupField;
